import React, { useState } from "react"
import style from "../components/kijkItemMobile.module.scss"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

export default function KijkItemMobile({ beeld, geluid, info, mediaType }) {
  const [content, setContent] = useState()
  const [focus, setFocus] = useState(false)
  return (
    <div className={style.wrapper}>
      <div className={style.beeld}>
        {beeld.map(foto => {
          const pic = getImage(foto)
          return (
            foto && (
              <GatsbyImage
                className={style.Image}
                image={pic}
                onClick={() => {
                  setContent(pic)
                  setFocus(true)
                }}
              ></GatsbyImage>
            )
          )
        })}
      </div>
      <div className={style.info}>
        <h3>{`${info.voornaam} ${info.achternaam}`}</h3>
        {info.link && (
          <a
            className={style.link}
            href={info.link}
            target="_blank"
            rel="noreferrer"
          >
            video
          </a>
        )}
        <h5>{info.locatie}</h5>
        <h4>{info.programmaType}</h4>
      </div>
      {focus && (
        <div className={style.focus}>
          {/* <button onClick={() => setFocus(false)}>close</button> */}
          <GatsbyImage
            className={style.focusImage}
            imgClassName={style.focusImage}
            image={content}
            onMouseDown={() => setFocus(false)}
          ></GatsbyImage>
        </div>
      )}
    </div>
  )
}
